import { Injectable, NgZone } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AMapService } from '../../shared/amap.service';
import { LoggerService } from '../../shared/logger/logger.service';
import { Getter } from '../../base/interfaces';

const TAG = 'AmapCircleMarker';

@Injectable()
export class AmapCircleMarkerService implements Getter<AMap.CircleMarker> {
  private circle: AMap.CircleMarker;
  private circle$ = new ReplaySubject<AMap.CircleMarker>(1);

  constructor(private amaps: AMapService, private logger: LoggerService, private ngZone: NgZone) {}

  /**
   * è·ååç¹æ è®°
   */
  get() {
    return this.circle$.asObservable();
  }

  /**
   * åå»ºåç¹æ è®° AMap.CircleMarker
   * @param options éé¡¹
   */
  create(options: AMap.Circle.Options) {
    return this.amaps.get().pipe(
      map(m => {
        options.map = m;
        this.circle = this.ngZone.runOutsideAngular(() => new AMap.CircleMarker(options));
        this.logger.d(TAG, 'new CircleMarker created.');
        this.circle$.next(this.circle);
        this.circle$.complete();
        return this.circle;
      }),
    );
  }

  /**
   * éæ¯åç¹æ è®°
   */
  destroy() {
    this.get().subscribe(m => {
      m.setMap(null);
      this.logger.d(TAG, 'CircleMarker destroyed.');
      this.circle = null;
    });
  }
}
